import { proofReportArtifactId } from "../proof/proofReportArtifactId";
import type { ProofIndexEntry } from "./proofIndexEntry";

export function proofReportPaneQuery(childSessionId: string): string {
  return new URLSearchParams({
    pane: proofReportArtifactId(childSessionId),
    focus: "proof",
  }).toString();
}

/**
 * The session the Proof was started from, with its report open in the
 * workspace pane, else the Proof's own session: parent `ses_p`, proof `ses_1`
 * → `/sessions/ses_p?pane=proof-report%3Ases_1&focus=proof`.
 */
export function proofReportSessionPath(
  entry: Pick<ProofIndexEntry, "sessionId" | "parentSessionId">,
): string {
  if (!entry.parentSessionId) return `/sessions/${entry.sessionId}`;
  return `/sessions/${entry.parentSessionId}?${proofReportPaneQuery(entry.sessionId)}`;
}
